export default "__VITE_ASSET__DD4$gaBO__"